<template>
  <!-- 付款记录 -->
  <zl-dialog class="zl-saas" title="付款记录" ref="dialog" width="700px" :close-on-click-modal="false">
    <div class="order-content-detail">
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="common-item">
            <span>付款单号：</span>
            <span>{{detailInfo.orderPayCode}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="common-item">
            <span>申请付款金额(元)：</span>
            <span class="money-color__orange">{{detailInfo.applyMoney}}</span>
            <span>{{currencyCH}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="common-item">
            <span>备注：</span>
            <span>{{detailInfo.applyRemark}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="common-item">
            <span>付款方式：</span>
            <span>{{getValue('payType', detailInfo.payWay)}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="common-item">
            <span>实际付款金额(元)：</span>
            <span class="money-color__orange">{{_util.formatMoney(detailInfo.realMoney)}}</span>
            <span>{{currencyCH}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="common-item">
            <span>付款说明：</span>
            <span>{{detailInfo.payRemark}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="common-item">
            <span>已支付的证明附件1：</span>
            <zsFileDownload :fileId="detailInfo.fileId"/>
          </div>
        </el-col>
      </el-row>
    </div>
  </zl-dialog>
</template>
<script>
import { getValue } from '@/lib/enum'
import zsFileDownload from '@/components/zsFileDownload'
export default {
  components: {
    zsFileDownload
  },
  data() {
    return {
      detailInfo: {},
      getValue,
      currencyCH: '人民币'
    }
  },
  methods: {
    async open(args) {
      this.detailInfo = args.detailInfo
      if (args.currencyCH) {
        this.currencyCH = args.currencyCH
      }
      return this.$refs.dialog.open()
    },
    cancel() {
      this.$refs.dialog.cancel()
    }
  }
}
</script>
